import React from 'react';
import styled from 'styled-components';
import { getSize, Breakpoints } from '../../DesignSystem/design-system';
const Spacer = styled.div `
  ${({ height, width, isVisible }) => `
    background-color: ${isVisible ? 'lightgray' : 'transparent'};
    height: ${getSize(height || 'none')};
    width: ${getSize(width || 'none')};
  `}
  @media (max-width: ${Breakpoints.Mobile}) {
    ${({ mobileHeight, mobileWidth }) => `
      ${mobileHeight ? `height: ${getSize(mobileHeight)}` : ''}
      ${mobileWidth ? `width: ${getSize(mobileWidth)}` : ''}
    `}
  }
`;
/**
 * `ImpSpacer` is a responsive layout component used to create space in the layout (much like the CSS margin property).
 *
 * @component
 * @param {object} props The properties for the component.
 * @param {size} props.height The height of the spacer. If both height and width are defined, this value will be used. Defaults to 100%.
 * @param {size} props.width The width of the spacer. If both height and width are defined, this value will be used. Defaults to 100%.
 * @param {size} props.mobileHeight The height of the spacer on mobile viewports. If not defined, it falls back to the default height.
 * @param {size} props.mobileWidth The width of the spacer on mobile viewports. If not defined, it falls back to the default width.
 * @param {boolean} props.isVisible If true, the spacer will be visible with a lightgray background color. Defaults to false.
 * @returns {React.Component} The `ImpSpacer` component.
 */
export default function ImpSpacer({ isVisible = false, ...args }) {
    return React.createElement(Spacer, { isVisible: isVisible, ...args, "data-testid": "spacer" });
}
//# sourceMappingURL=ImpSpacer.js.map